/**
 * TanStack Query hooks for `campaign-os-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignOsTargetingQueryKeys,
	type CreateCampaignOsTargetingBody,
	type ListCampaignOsTargetingResponse,
	type CampaignOsTargetingRow,
} from "./api";

export function useCampaignOsTargetingList(): UseQueryResult<ListCampaignOsTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignOsTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignOsTargetingCreate(): UseMutationResult<CampaignOsTargetingRow, Error, CreateCampaignOsTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignOsTargetingQueryKeys.all });
		},
	});
}

export function useCampaignOsTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignOsTargetingQueryKeys.all });
		},
	});
}
